export const SITE = {
  SIGN_IN: '/sign-in',
  HOME: '/home',
  PROFILE: '/profile',
  FILE_MANAGER: '/file-manager',
  DASHBOARD: '/dashboard',
  WORKSPACE: '/workspace',
  FILE_PAGE: '/file-page'
}
